import { apiFetch } from '../api';

export const getCityList = (statusId) => {
  return apiFetch(`/DailyCallCity/Search?isActive=${statusId}`);
};

export const getCityListCombo = () => {
  return apiFetch(`/DailyCallCity/GetForCombo?includeSelect=false`);
};

export const saveCityAPI = (payload) => {
  return apiFetch(`/DailyCallCity/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteCityAPI = (cityGUID) => {
  return apiFetch(`/DailyCallCity/Delete?DailyCallCityGUID=${cityGUID}`, {
    method: 'POST'
  });
};

export const getAreaList = (statusId) => {
  return apiFetch(`/DailyCallArea/Search?isActive=${statusId}`);
};

export const getAreaListCombo = () => {
  return apiFetch(`/DailyCallArea/GetForCombo?includeSelect=false`);
};

export const saveAreaAPI = (payload) => {
  return apiFetch(`/DailyCallArea/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteAreaAPI = (AreaGUID) => {
  return apiFetch(`/DailyCallArea/Delete?DailyCallAreaGUID=${AreaGUID}`, {
    method: 'POST'
  });
};

export const getClientList = (payload) => {
  return apiFetch(`/DailyCallClient/Search`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getClientById = (clientGUID) => {
  return apiFetch(`/DailyCallClient/GetById?dailyCallClientGUID=${clientGUID}`);
};

export const addClient = (data) => {
  return apiFetch(`/DailyCallClient/Write`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

export const deleteClientAPI = (clientGUID) => {
  return apiFetch(`/DailyCallClient/Delete?DailyCallClientGUID=${clientGUID}`, {
    method: 'POST'
  });
};

export const getDcrList = (payload) => {
  return apiFetch(`/DailyCall/Search`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getDcrListById = (clientGUID) => {
  return apiFetch(`/DailyCall/GetById?dailyCallGUID=${clientGUID}`);
};

export const addDcrList = (data) => {
  return apiFetch(`/DailyCall/Write`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

export const deleteDcrListAPI = (clientGUID) => {
  return apiFetch(`/DailyCall/Delete?dailyCallGUID=${clientGUID}`, {
    method: 'POST'
  });
};
